$(document).ready(function () {
	// Target every section and add the fade-up attribute
	// $("section.shopify-section").attr("data-aos", "fade-up");
	$("section.shopify-section").each(function () {
		let check = $(this).find(".no-aos").hasClass("no-aos");
		if (check == false) {
			$(this).attr("data-aos", "fade-up");
		}
	});

	// Initialize the AOS library after the attributes are set
	AOS.init({
		duration: 500, // Duration of the animation in milliseconds
		offset: 200,
		once: true, // Keeps the animation firing every time you scroll up/down
	});
});

window.addEventListener("load", () => {
	AOS.refresh();
});
